export function ContractCardSkeleton() {
  return (
    <div className="w-full animate-pulse rounded-xl border-2 border-light-gray-1 px-[17px] pt-[10px] pb-3">
      <div className="flex items-center justify-between gap-4">
        <span className="h-4 w-24 rounded bg-light-gray-1" />
        <span className="h-4 w-28 rounded bg-light-gray-1" />
      </div>

      <hr className="mt-[14px] border-t border-divider-strong" />

      <span className="mt-[11px] block h-4 w-12 rounded bg-light-gray-1" />
      <span className="mt-2 block h-4 w-full rounded bg-light-gray-1" />
      <span className="mt-1.5 block h-4 w-4/5 rounded bg-light-gray-1" />
      <span className="mt-[9px] block h-4 w-2/5 rounded bg-light-gray-1" />
    </div>
  );
}
